import React, { createContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routesContent.json";

export const ExpiredLinkContext = createContext({});
export const ExpiredLinkContextProvider = ({ children }) => {
  const location=useLocation();
  const navigate = useNavigate();
  const errorMessage = location?.state;
  const otpExpiryStatus=location?.state?.otpExpiryStatus;
  const goBack = () => {
    if(otpExpiryStatus){
      navigate(RouteConstants?.MOBILE_OTP)
    }
    else{
    navigate(RouteConstants.LOGIN)
  }
};

  const providerValue = {
    errorMessage,
    goBack
  };
  return (
    <ExpiredLinkContext.Provider value={providerValue}>
      {children}
    </ExpiredLinkContext.Provider>
  );
};
